<template>
  <SfDropdownMultiselect
    v-model="tags"
    data-testid="tags-filter-dropdown"
    :options="options"
    dropdown-id="tagsDropdownFilter"
    :placeholder="I18n.t('inbox.filters.tags.search_placeholder')"
    :trigger-label="I18n.t('inbox.filters.trigger_labels.tags')"
  >
    <template #before>
      <SfDropdownItem
        class="tw-leading-3"
        :has-checkmark="tags.length === 0"
        :has-border="false"
        :class="{ 'tw-font-medium': tags.length === 0 }"
        @click="clearSelected"
      >
        {{ I18n.t('inbox.filters.note_types.labels.any') }}
      </SfDropdownItem>
    </template>
  </SfDropdownMultiselect>
</template>

<script setup lang="ts">
import { useInboxFiltersStore } from '../store/inbox-filters'
import SfDropdownMultiselect from '@app/shared/vue/components/sf-dropdown/sf-dropdown-multiselect.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { storeToRefs } from 'pinia'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'

interface Props {
  options: Array<
    Array<{
      label: string
      value: string
      icon?: string
      iconColor?: string
    }>
  >
}

const I18n = useI18n()
defineProps<Props>()
const inboxFiltersStore = useInboxFiltersStore()
const { tags } = storeToRefs(inboxFiltersStore)

function clearSelected(): void {
  tags.value = []
}
</script>
